import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isVerifying"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { H3 } from 'foundations-components/transitional/components/H3';
import { CodeEntryForm } from './CodeEntryForm';
import { useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TwoFactorHubspotAppForm = _ref => {
  let {
      isVerifying
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [didNotGetPromptModalOpen, setDidNotGetPromptModalOpen] = useState(false);
  const openModal = useCallback(() => {
    setDidNotGetPromptModalOpen(true);
  }, []);
  const closeModal = useCallback(() => {
    setDidNotGetPromptModalOpen(false);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "mobile-notify",
      width: "215px"
    }), /*#__PURE__*/_jsx(H4, {
      "aria-level": 1,
      marginBlockStart: "700",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `twoFactorV4.hubspotApp.title`
      })
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `twoFactorV4.hubspotApp.description`
      })
    }), /*#__PURE__*/_jsx(Button, {
      disabled: isVerifying,
      onClick: openModal,
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `twoFactorV4.hubspotApp.didNotGetPrompt`
      })
    }), didNotGetPromptModalOpen && /*#__PURE__*/_jsx(Modal, {
      children: /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(H3, {
          "aria-level": 1,
          marginBlockEnd: "600",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "twoFactorV4.hubspotApp.modal.title"
          })
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "twoFactorV4.hubspotApp.modal.description"
        }), /*#__PURE__*/_jsx(CodeEntryForm, Object.assign({}, props, {
          closeModal: closeModal,
          isVerifying: isVerifying
        }))]
      })
    })]
  });
};